var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAF119"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7256 36.7838L30.8479 27.9761C32.6662 25.4673 33.5754 22.2645 33.0941 18.8481C32.2919 13.1364 27.6391 8.59914 21.8098 8.06534C13.9483 7.26463 7.26327 13.9372 8.06547 21.8374C8.60027 27.5491 13.1461 32.2999 18.8684 33.1006C22.2911 33.581 25.4464 32.6202 28.0135 30.8587L36.8911 39.7198C37.2655 40.0934 37.9073 40.0934 38.2816 39.7198L39.6721 38.3319C40.0999 37.8514 40.0999 37.2109 39.7256 36.7838ZM12.023 20.5563C12.023 15.8588 15.8735 11.9621 20.6332 11.9621C25.393 11.9621 29.2435 15.8055 29.2435 20.5563C29.2435 25.3071 25.393 29.1505 20.6332 29.1505C15.8735 29.1505 12.023 25.3605 12.023 20.5563Z",
    fill: "#161717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e37e0f25e3b5032faea8f8864321d09e.svg";
export { ForwardRef as ReactComponent };